<template>
  <div class="account-node">
    <div class="account-row" :class="{ 'has-children': hasChildren }"
         :style="{ paddingLeft: (level * 20 + 16) + 'px' }" 
         @click.stop="hasChildren ? toggleNode() : null">
      <div class="expand-icon" v-if="hasChildren">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" :class="{ 'rotated': isExpanded }">
          <path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
        </svg>
      </div>
      <div class="expand-placeholder" v-else></div>

			<div class="account-info">
				<div class="account-header">
					<div class="account-badges">
						<span class="badge badge-account">{{ account.account }}</span>
						<span class="badge badge-level">Nivel {{ account.level }}</span>
						<span class="badge badge-code">{{ account.code }}</span>
					</div>
					<div class="account-balance">
						<span class="balance-label">Balance:</span>
						<span class="balance-value" :class="getBalanceClass(account.balance)">
							{{ formatCurrency(account.balance) }}
						</span>
					</div>
				</div>
				<h3 class="account-name">{{ account.name }}</h3>
				<div class="account-details">
					<span class="total-amount">Total: {{ formatCurrency(account.totalAmount) }}</span>
					<span class="balance-type" :class="getBalanceTypeClass(account.balance)">
						{{ getBalanceType(account.balance) }}
					</span>
				</div>
			</div>
    </div>

    <div v-if="hasChildren && isExpanded" class="children-container">
      <AccountNode 
        v-for="child in account.children" 
        :key="child.id" 
        :account="child" 
        :level="level + 1"
        :expanded-nodes="expandedNodes" 
        @toggle="handleChildToggle" />
    </div>
  </div>
</template>

<script>
export default {
	name: 'AccountNode',
	props: {
		account: { type: Object, required: true },
		level: { type: Number, default: 0 },
		expandedNodes: { type: Set, required: true },
		viewMode: { type: String, default: 'single' },
	},
	computed: {
		hasChildren() {
			console.log('this.accccc::: ');
			return this.account.children && this.account.children.length > 0;
		},
		isExpanded() {
			return this.expandedNodes.has(this.account.id);
		},
	},
	methods: {
		handleChildToggle(nodeId) {
			console.log('nodeId::: ', nodeId);
			this.$emit('toggle', nodeId);
		},
		formatCurrency(amount) {
			return new Intl.NumberFormat('es-CO', {
				style: 'currency',
				currency: 'COP',
				minimumFractionDigits: 2,
				signDisplay: 'always', // Muestra el signo para negativos
			}).format(amount); // Sin Math.abs
		},
		getBalanceClass(balance) {
			if (balance > 0) return 'balance-debit';
			if (balance < 0) return 'balance-credit';
			return 'balance-neutral';
		},
		getBalanceType(balance) {
			if (balance > 0) return 'Débito';
			if (balance < 0) return 'Crédito';
			return 'Neutro';
		},
		getBalanceTypeClass(balance) {
			if (balance > 0) return 'type-debit';
			if (balance < 0) return 'type-credit';
			return 'type-neutral';
		},
		toggleNode() {
			console.log('this.account::: ', this.account);
			this.$emit('toggle', this.account.id);
		},
	},
};
</script>

<style scoped lang="scss">
.account-node {
	width: 100%;
}

.account-row {
	display: flex;
	align-items: flex-start;
	padding: 16px;
	border-bottom: 1px solid #f1f5f9;
	transition: all 0.2s ease;
	cursor: default;
}

.account-row.has-children {
	cursor: pointer;
}

.account-row:hover {
	background: #f8fafc;
}

.expand-icon {
	margin-right: 12px;
	color: #02979B;
	transition: transform 0.2s ease;
	margin-top: 2px;
}

.rotated {
  transform: rotate(90deg);
  transition: transform 0.2s ease;
}

.expand-placeholder {
	width: 16px;
	margin-right: 12px;
}

.account-info {
	flex: 1;
	min-width: 0;
}

.account-header {
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	margin-bottom: 8px;
	flex-wrap: wrap;
	gap: 8px;
}

.account-badges {
	display: flex;
	gap: 6px;
	flex-wrap: wrap;
}

.badge {
	padding: 2px 8px;
	border-radius: 12px;
	font-size: 11px;
	font-weight: 600;
	text-transform: uppercase;
}

.badge-account {
	background: #02979B;
	color: white;
}

.badge-level {
	background: #e2e8f0;
	color: #4a5568;
}

.badge-code {
	background: #fed7d7;
	color: #c53030;
}

.account-balance {
	display: flex;
	align-items: center;
	gap: 8px;
}

.balance-label {
	font-size: 12px;
	color: #718096;
	font-weight: 500;
}

.balance-value {
	font-size: 14px;
	font-weight: 700;
}

.balance-credit {
	color: #02979B;
}

.balance-debit {
	color: #e53e3e;
}

.balance-neutral {
	color: #718096;
}

.account-name {
	font-size: 16px;
	font-weight: 600;
	color: #1a202c;
	margin: 0 0 8px 0;
	line-height: 1.4;
}

.account-details {
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	gap: 8px;
}

.total-amount {
	font-size: 12px;
	color: #718096;
}

.balance-type {
	padding: 2px 8px;
	border-radius: 12px;
	font-size: 10px;
	font-weight: 600;
	text-transform: uppercase;
}

.type-credit {
	background: #c6f6d5;
	color: #22543d;
}

.type-debit {
	background: #fed7d7;
	color: #742a2a;
}

.type-neutral {
	background: #e2e8f0;
	color: #4a5568;
}

.children-container {
	background: #f8fafc;
}
</style>


// WEBPACK FOOTER //
// src/components/records/account-node.vue